import React, { useState } from "react";
// import { Switch } from "@headlessui/react";

const Filter = () => {
  const filters = [
    {
      id: "Product Category",
      name: "Product Category",
      options: [
        { value: "ALL", label: "ALL" },
        { value: "Electronics", label: "Electronics" },
        { value: "Fashion and Apparel", label: "Fashion and Apparel" },
        { value: "Home and Kitchen", label: "Home and Kitchen" },
        {
          value: "Beauty and Personal Care",
          label: "Beauty and Personal Care",
        },
        { value: "Books and Media", label: "Books and Media" },
        { value: "Sports and Fitness", label: "Sports and Fitness" },
        { value: "Toys and Games", label: "Toys and Games" },
        { value: "Health and Wellness", label: "Health and Wellness" },
        {
          value: "Automotive and Accessories",
          label: "Automotive and Accessories",
        },
        { value: "Baby and Maternity", label: "Baby and Maternity" },
        {
          value: "Furniture and Home Decor",
          label: "Furniture and Home Decor",
        },
        { value: "Jewelry and Watches", label: "Jewelry and Watches" },
        { value: "Pet Supplies", label: "Pet Supplies" },
        {
          value: "Tools and Home Improvement",
          label: "Tools and Home Improvement",
        },
      ],
    },
  ];

  const [gridView, setGridView] = useState(false);
  const [menCategory, setMenCategory] = useState(false);

  return (
    <div className="mx-auto py-8 px-4 w-full max-w-7xl bg-white">
      <div className="relative">
        {/* :HEAD TITLE */}
        <div className="pb-10 sm:py-10 flex flex-col items-center border-b-2 border-gray-200 text-center">
          {/* ::Title */}
          <h1 className="text-3xl sm:text-4xl text-gray-700 font-extrabold">
            New Arrivals
          </h1>
          {/* ::Text */}
          <p className="mt-5 max-w-xl text-base text-gray-500 font-medium">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Inventore
            illo natus doloremque necessitatibus obcaecati harum dolorem?
          </p>
        </div>

        {/* :FILTERS CONTAINER */}
        <div className="py-5 sm:px-4 flex flex-col-reverse md:flex-row items-center justify-between">
          {/* ::Filter Select Input */}
          <div className="flex-shrink-0 mt-5 md:mt-0 max-w-sm sm:max-w-none w-full md:w-auto grid sm:grid-flow-col grid-cols-1 sm:auto-cols-fr gap-4">
            {filters.map((filter) => (
              <div key={filter.id} className="col-span-1">
                <label htmlFor={filter.id} className="sr-only">
                  {filter.name}
                </label>
                <select
                  name={filter.id}
                  id={filter.id}
                  defaultValue={filter.name}
                  className="form-select w-full rounded border border-gray-300 text-base text-gray-900 focus:border-blue-500 focus:ring-blue-500 py-2 px-4"
                >
                  <option value="" className="font-semibold">
                    {filter.name}
                  </option>
                  {filter.options.map((option) => (
                    <option value={option.value} key={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            ))}
          </div>

          <div className="flex-grow lg:ml-5 w-full flex items-center justify-around md:justify-between space-x-4">
            {/* ::View Grid */}
            <span className="inline-flex">
              {/* :::grid view button */}
              <button
                className={`inline-flex justify-center items-center ${
                  gridView
                    ? "text-blue-500"
                    : "text-gray-400 hover:text-gray-600"
                }`}
                onClick={() => setGridView(true)}
              >
                {/* <ViewGridIcon className="w-8 h-8" /> */}
              </button>
              {/* ::list view button*/}
              <button
                className={`ml-2 inline-flex justify-center items-center ${
                  !gridView
                    ? "text-blue-500"
                    : "text-gray-400 hover:text-gray-600"
                }`}
                onClick={() => setGridView(false)}
              >
                {/* <ViewListIcon className="w-8 h-8" /> */}
              </button>
            </span>
            {/* ::Search Bar */}
            <div className="flex items-center space-x-2">
              <input
                type="text"
                placeholder="Search..."
                className="py-2 px-8 sm:w-auto border border-gray-300 rounded bg-gray-100 text-base text-gray-600 focus:outline-none focus:border-blue-500 focus:ring-blue-500"
              />
              <button className="text-gray-400 hover:text-gray-600 bg-blue-500 rounded-full p-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path d="M22 12l-20 12 7.289-12-7.289-12z" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Filter;
